export default __webpack_public_path__ + "static/media/com-manager.34c88488.jpg";